module.exports = __webpack_public_path__ + "bolivia.svg?2676eec7664dc0035a231991b3e21586";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/bolivia.svg
// module id = 113
// module chunks = 10